import React from 'react';
import { Outlet , useLocation} from 'react-router-dom';

// project imports
import TopNavComponent from '../components/top-nav/top-nav';
import SideNavComponent from '../components/side-nav/side-nav';
import FooterComponent from "../components/footer/footer";
import '../App.scss';

const DashboardLayout = () => {
    return (
        <>
        <div className="container-fluid p-0 d-app-grid">
          <div className="app-grid-side-nav">
            <SideNavComponent />
          </div>
          <div className="app-grid-top-nav">
            <TopNavComponent />
          </div>
          <div className="app-grid-content">
            <main className="h-100" style={{ padding: "24px", width: "100%"}}>
            <div className="router-page-wrapper" style={{ height: "100%" }}>
              <Outlet />
              </div>
            </main>
          </div>
          <div className="app-grid-footer">
            <FooterComponent />
          </div>
        </div>
        </>
    )
};

export default DashboardLayout;

